import { createActionTypeModel } from "../../../../store/global/action-model";

export const ExternalUsers = createActionTypeModel('ExternalUsers');
export const AllExternalUsers = createActionTypeModel('AllExternalUsers');
export const SearchExternalUsers = createActionTypeModel('SearchExternalUsers');
export const SelectedExternalUser = createActionTypeModel('SelectedExternalUser');
export const SELECT_EXTERNAL_USER_AUTO = 'SELECT_EXTERNAL_USER_AUTO';
export const RoyaltyAccounts = createActionTypeModel('RoyaltyAccounts');
export const ExternalUserDetails = createActionTypeModel('ExternalUserDetails');

